module.exports = __webpack_public_path__ + "img/13.a2d1d776.png";